/** Normalize Puck page JSON for @measured/puck (content must be an array). */
export function normalizePuckStructure(structure) {
  if (!structure || typeof structure !== "object") {
    return { content: [], root: {}, zones: {} };
  }
  let content = structure.content;
  if (Array.isArray(content)) {
    content = content;
  } else if (content && typeof content === "object") {
    content = Object.values(content);
  } else {
    content = [];
  }

  const zones = structure.zones && typeof structure.zones === "object" ? structure.zones : {};
  const normalizedZones = {};
  Object.keys(zones).forEach((zoneKey) => {
    const zoneVal = zones[zoneKey];
    if (Array.isArray(zoneVal)) {
      normalizedZones[zoneKey] = zoneVal;
    } else if (zoneVal && typeof zoneVal === "object") {
      normalizedZones[zoneKey] = Object.values(zoneVal);
    } else {
      normalizedZones[zoneKey] = [];
    }
  });

  return {
    content,
    root: structure.root && typeof structure.root === "object" ? structure.root : {},
    zones: normalizedZones,
  };
}

export function puckContentItems(content) {
  if (Array.isArray(content)) return content;
  if (content && typeof content === "object") return Object.values(content);
  return [];
}

/** Depth-first walk of Puck trees (matches backend commit walker). */
export function walkPuckNodes(nodes, zones, visit) {
  if (!Array.isArray(nodes) || typeof visit !== "function") return;
  for (const node of nodes) {
    if (!node) continue;
    visit(node);
    const id = node.props?.id;
    if (!id || !zones || typeof zones !== "object") continue;
    if (node.type === "Wrapper") walkPuckNodes(zones[`${id}:wrapper`], zones, visit);
    if (node.type === "Columns") {
      const colCount = node.props?.columns?.length || 2;
      for (let i = 0; i < colCount; i++) {
        walkPuckNodes(zones[`${id}:column-${i}`], zones, visit);
      }
    }
    if (node.type === "TransparentSection") {
      walkPuckNodes(zones[`${id}:section`], zones, visit);
    }
  }
}

export function resolveRadioGroupValue(props) {
  if (!props) return "";
  const items = props.items;
  let raw = props.value ?? props.default_value;
  if (raw === undefined || raw === null || raw === "") return "";
  if (typeof raw === "number" || (typeof raw === "string" && raw !== "" && !Number.isNaN(Number(raw)))) {
    const idx = Number(raw);
    if (Array.isArray(items) && items[idx] != null) {
      const it = items[idx];
      return String(it.value ?? it.RadioOption ?? "");
    }
    if (items && typeof items === "object" && !Array.isArray(items)) {
      const keys = Object.keys(items).sort((a, b) => Number(a) - Number(b));
      const it = items[keys[idx]];
      if (it) return String(it.value ?? it.RadioOption ?? "");
    }
  }
  return String(raw);
}
